import { imageContentType } from '@krp/ui-kit'

/** Предел сервера (`ProductSearchService.MaxFrameBytes`): кадр не сжимается в браузере и уходит как выбран. */
export const MAX_PHOTO_BYTES = 30 * 1024 * 1024

const MIB = 1024 * 1024

/**
 * Что не так с выбранным снимком ДО отправки; `null` — можно искать. Сервер перепроверяет и отвечает своими словами (они показываются дословно).
 * Тип берётся по расширению, если браузер не назвал его (HEIC в Chrome на Windows): сам файл при этом не меняется.
 */
export function photoProblem(file: { size: number; type: string; name?: string }): string | null {
  if (file.size === 0) return 'Пустой файл'
  if (file.size > MAX_PHOTO_BYTES) return `Файл больше ${MAX_PHOTO_BYTES / MIB} МБ`
  if (!imageContentType(file).startsWith('image/')) return 'Нужна фотография: выберите файл изображения'
  return null
}
